import React from 'react';
import Button from '@atlaskit/button/standard-button';
import ModalDialog, {
  ModalTransition,
  ModalBody,
  ModalTitle,
  ModalHeader,
  ModalFooter,
} from '@atlaskit/modal-dialog';
import { useSelector } from 'react-redux';
import { selectLicenseDetails } from 'modules/mac/duck/selectors/license';
import { State } from 'model/State';
import { FormattedMessage } from 'react-intl';
import TextArea from '@atlaskit/textarea';

const Dialog = ({ close, license }) => (
  <ModalDialog autoFocus shouldCloseOnEscapePress width="medium">
    <ModalHeader>
      <ModalTitle>
        <FormattedMessage
          id="mac.licenses.developer-license-modal.title.license-key"
          defaultMessage="License Key"
        />
      </ModalTitle>
    </ModalHeader>
    <ModalBody>
      <p>{license.licenseDetails.description}</p>
      <p>{license.licenseDetails.organisation}</p>
      <p>
        <TextArea
          cols={66}
          rows={15}
          maxHeight="30vh"
          readOnly
          value={license.licenseDetails.license}
          onClick={(e) => {
            e.currentTarget.select();
          }}
        />
      </p>
    </ModalBody>
    <ModalFooter>
      <Button
        onClick={close}
        appearance="primary"
        data-cy="actions-section-end-user-license-key-dialog-primary-button"
      >
        <FormattedMessage
          id="mac.licenses.developer-license-modal.button.close"
          defaultMessage="Close"
        />
      </Button>
    </ModalFooter>
  </ModalDialog>
);

const EndUserLicenseKeyDialog = ({ licenseId, isModalOpened, setIsModalOpened }) => {
  const license = useSelector((state) => selectLicenseDetails(state as State, licenseId));

  const onClose = () => {
    setIsModalOpened(false);
  };

  return (
    <ModalTransition>
      {isModalOpened && license && <Dialog close={onClose} license={license} />}
    </ModalTransition>
  );
};

export default EndUserLicenseKeyDialog;
